import React from "react";
import "normalize.css";
import "./assets/styles/app.sass";
import Header from "./components/Header";
import Navigation from "./components/Navigation";

import ProgressCollection from "./components/ProgressCollection";
import Footer from "./components/Footer";
import websiteImage from "./assets/images/logo_transparent.png";

export default class App extends React.Component {
  state = {
    toggleMenu: false
  };

  menuButtonClick() {
    this.setState({
      toggleMenu: !this.state.toggleMenu
    });
  }

  render() {
    return (
      <div>
        <Header />
        <Navigation
          handleClick={this.menuButtonClick.bind(this)}
          toggle={this.state.toggleMenu}
        />
        <h1 className="title-section">
          <div className="content-large">Projects</div>
        </h1>
        <section
          className="content-full"
          style={{ backgroundColor: "#333841" }}
        >
          <div className="content-large">
            <div className="project-item ">
              <div className="project-column">
                <div className="project-text project-cell">
                  <div className="project-name">
                    <h2>CodeTuts</h2>
                  </div>
                  <p>
                    Everybody is blogging these days. In order to grow as I
                    developer I feel the need to share what I've learned in the
                    process, this is why I've created a YouTube Channel along
                    with a blog where I can post tutorials and new projects.
                  </p>
                </div>
              </div>

              <div className="project-column project-image">
                <div className="project-cell">
                  <img src={websiteImage} alt="CodeTuts logo" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <h1 className="title-section">
          <div className="content-large">Skills</div>
        </h1>
        <ProgressCollection />
        <Footer />
      </div>
    );
  }
}
